import { jsx as _jsx } from "react/jsx-runtime";
import { sans } from '../fonts.js';
/** Slugs come from the catalog; keep the link and the id to a safe
 *  alphabet even if ops ever saves something odd. */
const SLUG_RE = /^[a-z0-9][a-z0-9-]{0,39}$/;
export function safeSlug(slug) {
    return SLUG_RE.test(slug) ? slug : null;
}
/** Build the sign-up link for a plan. Unknown or unsafe slugs fall
 *  back to the bare link, which signs up on Free. */
export function planCtaHref(ctaHref, slug, interval) {
    const s = safeSlug(slug);
    if (s === null)
        return ctaHref;
    const sep = ctaHref.includes('?') ? '&' : '?';
    return `${ctaHref}${sep}plan=${encodeURIComponent(s)}&interval=${interval === 'yearly' ? 'yearly' : 'monthly'}`;
}
/** Click-tracking id, at most 64 characters (the experiment ingest
 *  cap). */
export function planCtaId(slug, location) {
    const s = safeSlug(slug) ?? 'unknown';
    return `pricing-${location}-${s}`.slice(0, 64);
}
function trackClick(id, interval) {
    if (typeof window === 'undefined')
        return;
    const w = window;
    try {
        w.sillExp?.track?.('cta_click', { cta_id: `${id}-${interval}`.slice(0, 64) });
    }
    catch {
        // Tracking is optional; the link still works.
    }
}
export function PlanCta(props) {
    const { slug, interval, location, ctaHref, theme, featured, accent = false, label, size = 'lg', style } = props;
    const isAccent = accent && !featured;
    const id = planCtaId(slug, location);
    const vars = {
        '--pr-cta-bg': featured ? theme.lime : theme.surface,
        '--pr-cta-fg': featured ? theme.ink : theme.text,
        '--pr-cta-border': featured ? theme.lime : isAccent ? theme.limeFg : theme.border,
        '--pr-cta-hover-bg': featured
            ? `color-mix(in oklab, ${theme.lime} 84%, #000)`
            : isAccent ? theme.lime : theme.text,
        '--pr-cta-hover-fg': featured || isAccent ? theme.ink : theme.bg,
        '--pr-cta-hover-border': featured ? `color-mix(in oklab, ${theme.lime} 84%, #000)` : isAccent ? theme.lime : theme.text,
        '--pr-cta-focus': theme.text,
    };
    return (_jsx("a", { id: id, className: `pr-cta${featured ? ' pr-cta-featured' : ''}${isAccent ? ' pr-cta-accent' : ''}`, href: planCtaHref(ctaHref, slug, interval), "data-plan": safeSlug(slug) ?? undefined, "data-interval": interval, "data-cta-location": location, onClick: () => trackClick(id, interval), style: {
            ...vars,
            ...sans,
            display: size === 'lg' ? 'block' : 'inline-block',
            textAlign: 'center',
            borderRadius: 2,
            padding: size === 'lg' ? '10px 12px' : '6px 10px',
            fontSize: size === 'lg' ? 14 : 13,
            fontWeight: 500,
            textDecoration: 'none',
            minHeight: size === 'lg' ? 44 : 32,
            boxSizing: 'border-box',
            ...style,
        }, children: label }));
}
//# sourceMappingURL=PlanCta.js.map